import { prefixObjectValues } from '../utils';

const chatbot = {
  input: 'input',
  sendBtn: 'send-btn',
  resetBtn: 'reset-btn',
  userMessage: 'user-message-',
  botMessage: 'bot-message-',
  openBtn: 'open-btn',
  closeBtn: 'close-btn',
};

export default prefixObjectValues(chatbot, 'chatbot');
